module.exports = __webpack_public_path__ + "img/triangle.0ee09cac.svg";